module.exports = __webpack_public_path__ + "df3e62e2919efefc89c4743140649ce7.jpg";